var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "landing" },
    [
      _c("el-row", [
        _c(
          "div",
          { staticClass: "landing-header-container" },
          [
            _c("Ticker"),
            _vm._v(" "),
            _c("Header", { staticClass: "landing-header" }, [
              !_vm.isMobile()
                ? _c("div", { staticClass: "landing-header-left" }, [
                    _c("div", { staticClass: "landing-header-title" }, [
                      _vm._v(
                        "\n                        Chicago Athenaeum Museum of Architecture and Design\n                    "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "landing-header-title" }, [
                      _vm._v(
                        "\n                        European Centre for Architecture Art Design and\n                        Urban Studies\n                    "
                      ),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "landing-header-middle" }, [
                _c("a", { attrs: { href: "https://awardapplication.com/" } }, [
                  _c("div", { staticClass: "landing-header-title" }, [
                    _vm._v("\n                            TCA - ECADUS "),
                    _c("br"),
                    _vm._v(
                      "\n                            AWARDS SUBMISSION PAGE\n                        "
                    ),
                  ]),
                ]),
              ]),
            ]),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "el-row",
        {
          staticStyle: {
            "margin-top": "60px",
            display: "flex",
            "justify-content": "center",
          },
        },
        [
          _c("div", { staticStyle: { width: "1600px" } }, [
            _c("h1", [_c("strong", [_vm._v("Returns")])]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n                The Chicago Athenaeum, European Centre and Metropolitan Arts\n                Press Ltd. (awardapplication.com), is the registered title\n                of a publication house running under The European Centre for\n                Architecture Art Design and Urban Studies in a collaboration\n                with The Chicago Athenaeum Museum of Architecture and\n                Design.\n            "
              ),
            ]),
            _vm._v(" "),
            _c("h1", [_c("strong", [_vm._v("Orders")])]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n                All orders are binding. In case of delivery delays you will\n                be informed as quickly as possible via e-mail.\n            "
              ),
            ]),
            _vm._v(" "),
            _c("h1", [_c("strong", [_vm._v("Prices and Descriptions")])]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n                Our prices are recommended sales prices including the\n                legally prescribed VAT.\n            "
              ),
            ]),
            _vm._v(" "),
            _c("h1", [
              _c("strong", [
                _vm._v(
                  "Payment Information - Credit Card - Bank\n                    Transfer"
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n                Your payment transaction will be handled by Elavon bank via\n                a certified, secure HTTPS connection. You will receive an\n                invoice from Metropolitan Arts Press Ltd. For Submissions\n                for the Good Design and American Architecture and from The\n                European Centre for Architecture Design and Urban Studies\n                for submissions for Green Good Design, International\n                Architecture Awards and Europe 40under40 Design Award via\n                e-mail.\n            "
              ),
            ]),
            _vm._v(" "),
            _c("h1", [
              _c("strong", [_vm._v("Type and Time of Invoice Delivery")]),
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n                Your order will be processed immediately. In the case of\n                delays you will be informed. The delivery time of the\n                invoice is determined by the type of payment either bank\n                transfer or credit card.\n            "
              ),
            ]),
            _vm._v(" "),
            _c("h1", [
              _c("strong", [_vm._v("Reservation of Proprietary Rights")]),
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n                Until receipt of payment the goods remain the property of\n                the publisher. In the case of late payment the publisher has\n                the right to withdraw from the contract and to request\n                return of the purchased goods.\n            "
              ),
            ]),
            _vm._v(" "),
            _c("h1", [_c("strong", [_vm._v("Cancellation of Orders")])]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n                Orders can be cancelled at any time. We will take back goods\n                which have already been delivered in perfect, condition\n                within 14 days against a credit note. Please always give\n                your invoice number and the reason for return. The return of\n                the goods shall be done at the risk and expense of the\n                customer\n            "
              ),
            ]),
            _vm._v(" "),
            _c("h1", [
              _c("strong", [
                _vm._v(
                  "Errors in Fulfilling Orders or Production\n                    Defects"
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n                In the case of errors in fulfilling orders or production\n                defects we will exchange the item in question for one in\n                perfect condition.\n            "
              ),
            ]),
            _vm._v(" "),
            _c("h1", [_c("strong", [_vm._v("Privacy Policy")])]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n                Metropolitan Arts Press Ltd. is running under The Chicago\n                Athenaeum Museum of Architecture in a βcollaboration with\n                The European Centre for Architecture Design and Urban\n                Studies and Design. It has committed themselves to protect\n                the privacy of all persons who use our website. No personal\n                information regarding the user will be shared with any\n                outside person orcompany.\n            "
              ),
            ]),
            _vm._v(" "),
            _c("h1", [_c("strong", [_vm._v("Court of Jurisdiction")])]),
            _vm._v(" "),
            _c("p", [_vm._v("Court of Jurisdiction is Illinois, USA.")]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("el-row", [
        _c("footer", [
          _c("section", { staticClass: "ft-main" }, [
            _c("div", { staticClass: "ft-main-item" }, [
              _c("div", { staticClass: "line" }),
              _vm._v(" "),
              _c("h2", { staticClass: "ft-title" }, [
                _vm._v("Awards Organizers"),
              ]),
              _vm._v(" "),
              _c("ul", [
                _c("li", [
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "https://www.chi-athenaeum.org/",
                        target: "_blank",
                      },
                    },
                    [_vm._v("The Chicago Athenaeum")]
                  ),
                ]),
                _vm._v(" "),
                _c("li", [
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "http://europeanarch.eu/",
                        target: "_blank",
                      },
                    },
                    [_vm._v("The European Centre")]
                  ),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "ft-main-item" }, [
              _c("div", { staticClass: "line" }),
              _vm._v(" "),
              _c("h2", { staticClass: "ft-title" }, [_vm._v("Legal")]),
              _vm._v(" "),
              _c("ul", [
                _c(
                  "li",
                  [
                    _c(
                      "router-link",
                      {
                        attrs: {
                          to: {
                            name: "terms-and-conditions",
                          },
                          target: "_blank",
                        },
                      },
                      [
                        _vm._v(
                          "\n                                Terms & Conditions\n                            "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "li",
                  [
                    _c(
                      "router-link",
                      {
                        attrs: {
                          to: {
                            name: "refund-policy",
                          },
                          target: "_blank",
                        },
                      },
                      [
                        _vm._v(
                          "\n                                Refund Policy\n                            "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "ft-main-item" }, [
              _c("div", { staticClass: "line" }),
              _vm._v(" "),
              _c("h2", { staticClass: "ft-title" }, [_vm._v("Connect")]),
              _vm._v(" "),
              _c("ul", [
                _c("li", [
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "https://www.instagram.com/thechicagoathenaeummuseum/",
                        target: "_blank",
                      },
                    },
                    [_vm._v("Instagram")]
                  ),
                ]),
                _vm._v(" "),
                _c("li", [
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "https://www.facebook.com/TheChicagoAthenaeumMuseum?ref=hlm",
                        target: "_blank",
                      },
                    },
                    [_vm._v("Facebook")]
                  ),
                ]),
                _vm._v(" "),
                _c("li", [
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "https://www.youtube.com/@thechicagoathenaeummuseum",
                        target: "_blank",
                      },
                    },
                    [_vm._v("Youtube")]
                  ),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "ft-main-item" }, [
              _c("div", { staticClass: "line" }),
              _vm._v(" "),
              _c("h2", { staticClass: "ft-title" }, [_vm._v("Contact")]),
              _vm._v(" "),
              _c("ul", [
                _c("li", [
                  _c("a", { attrs: { href: "#" } }, [
                    _vm._v("curatorial@chi-athenaeum.org"),
                  ]),
                ]),
                _vm._v(" "),
                _c("li", [
                  _c("a", { attrs: { href: "#" } }, [
                    _vm._v("tel: +1 815 777 4444 (extension 3000)"),
                  ]),
                ]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("section", { staticClass: "ft-legal" }, [
            _vm._v(
              "\n                © 2024 - 2026 All rights reserved for The Chicago\n                Athenaeum Museum of Architecture and Design , European\n                centre for Architecture Art Design and Urban Studies,\n                Metropolitan Arts Press Ltd.\n            "
            ),
          ]),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }